import axios from 'axios';
import { client } from '@/services/api/axios.ts';

type IRGetImageUrl = {
  uploadUrl: string;
  Key: string;
};

export async function getImageUrlPlant({
  id,
  file,
}: {
  id: string;
  file: File;
}): Promise<IRGetImageUrl | undefined | never> {
  try {
    const fileType = encodeURIComponent(file.type);

    const { data } = await client.get(`/plants/${id}/media/upload-url?fileType=${fileType}`);

    return data?.body;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}
